var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-clear-refinements',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var refine = ref.refine;
return _c('div',{},[_c('b-button',{attrs:{"variant":" iq-bg-primary iq-waves-effect","block":"","size":"sm"},on:{"click":function($event){$event.preventDefault();return refine($event)}}},[_c('i',{staticClass:"ri-restart-line font-size-18 mr-0"})])],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }